/* BOHOR · Trópico — interacción del tema (sin dependencias).
   Eventos delegados + re-init en shopify:section:load → aguanta el editor de temas. */
(function () {
  "use strict";

  var fmtCop = function (centavos) {
    return "$" + Math.round(centavos / 100).toLocaleString("es-CO");
  };
  var bloquear = function (si) { document.documentElement.style.overflow = si ? "hidden" : ""; };
  var reducido = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── Encabezado sólido al hacer scroll ── */
  var alScroll = function () {
    var encb = document.querySelector(".encb");
    if (!encb) return;
    encb.classList.toggle("solido", window.scrollY > 24 || !document.body.classList.contains("tpl-index"));
  };
  alScroll();
  window.addEventListener("scroll", alScroll, { passive: true });

  /* ── Barra de anuncio: rota mensajes (re-consulta el DOM en cada tick) ── */
  var anuncioIdx = 0;
  var rotarAnuncio = function () {
    var msgs = document.querySelectorAll(".anuncio-msg");
    if (msgs.length < 2) return;
    anuncioIdx = (anuncioIdx + 1) % msgs.length;
    msgs.forEach(function (m, i) { m.classList.toggle("on", i === anuncioIdx); });
  };
  setInterval(rotarAnuncio, 3800);

  /* ── Revelados ── */
  var io = null;
  if ("IntersectionObserver" in window && !reducido) {
    io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
  }
  var observarReveals = function (raiz) {
    (raiz || document).querySelectorAll(".rv").forEach(function (el) {
      if (io) io.observe(el);
      else el.classList.add("in");
    });
  };
  observarReveals(document);

  /* ── Toast ── */
  var toastTimer = null;
  var avisar = function (msg) {
    var toast = document.getElementById("aviso-toast");
    if (!toast) return;
    var texto = document.getElementById("toast-texto");
    if (texto && msg) texto.textContent = msg;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add("on"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove("on");
      setTimeout(function () { toast.hidden = true; }, 400);
    }, 2600);
  };

  /* ── Carrito: drawer + AJAX ── */
  var pintarCarrito = function (cart) {
    document.querySelectorAll("[data-bolsa-conteo]").forEach(function (b) {
      b.textContent = cart.item_count > 9 ? "9+" : cart.item_count;
      b.hidden = cart.item_count === 0;
    });
    var raiz = document.getElementById("carrito-drawer");
    if (!raiz) return;
    var hay = cart.item_count > 0;
    var vacioCaja = document.getElementById("drawer-vacio");
    var itemsCaja = document.getElementById("drawer-items");
    var pieCaja = document.getElementById("drawer-pie");
    var conteoTitulo = document.getElementById("drawer-conteo");
    var subtotalEl = document.getElementById("drawer-subtotal");
    if (vacioCaja) vacioCaja.hidden = hay;
    if (itemsCaja) itemsCaja.hidden = !hay;
    if (pieCaja) pieCaja.hidden = !hay;
    if (conteoTitulo) conteoTitulo.textContent = hay ? "· " + cart.item_count + (cart.item_count === 1 ? " pieza" : " piezas") : "";
    if (subtotalEl) subtotalEl.textContent = fmtCop(cart.items_subtotal_price);

    var envioCaja = document.getElementById("drawer-envio");
    if (envioCaja) {
      var envioMeta = parseInt(raiz.getAttribute("data-envio-gratis"), 10) || 0;
      if (envioMeta > 0 && hay) {
        envioCaja.hidden = false;
        var metaCent = envioMeta * 100;
        var falta = Math.max(0, metaCent - cart.items_subtotal_price);
        var pct = Math.min(100, (cart.items_subtotal_price / metaCent) * 100);
        var envioTexto = document.getElementById("drawer-envio-texto");
        var envioNivel = document.getElementById("drawer-envio-nivel");
        if (envioTexto) {
          envioTexto.innerHTML = falta > 0
            ? "Te faltan <strong>" + fmtCop(falta) + "</strong> para el envío gratis"
            : "<strong>¡Envío gratis listo! ⭐</strong>";
        }
        if (envioNivel) envioNivel.style.width = pct + "%";
      } else {
        envioCaja.hidden = true;
      }
    }

    if (!itemsCaja) return;
    itemsCaja.innerHTML = cart.items.map(function (it) {
      var foto = it.featured_image && it.featured_image.url ? it.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/, "_180x$1$2") : "";
      var talla = it.variant_title && it.variant_title !== "Default Title" ? "Talla " + it.variant_title : "";
      return (
        '<li class="item-carrito" data-key="' + it.key + '">' +
        '<a class="item-foto" href="' + it.url + '">' + (foto ? '<img src="' + foto + '" alt="" loading="lazy">' : "") + "</a>" +
        '<div class="item-cuerpo">' +
        '<div class="item-cabeza"><a class="item-nombre" href="' + it.url + '">' + it.product_title + "</a>" +
        '<span class="item-precio num">' + fmtCop(it.final_line_price) + "</span></div>" +
        (talla ? '<p class="item-talla">' + talla + "</p>" : "") +
        '<div class="item-pie"><div class="qty" role="group" aria-label="Cantidad">' +
        '<button type="button" data-qty="-1" aria-label="Quitar una unidad">−</button>' +
        '<span class="qty-n num">' + it.quantity + "</span>" +
        '<button type="button" data-qty="1" aria-label="Agregar una unidad">+</button></div>' +
        '<button type="button" class="item-quitar" data-quitar>Quitar</button></div>' +
        "</div></li>"
      );
    }).join("");
  };

  /* Guardia anti-carrera: varias peticiones pueden viajar a la vez (agregar dos
     prendas rápido, +1 seguido de quitar, etc.). Solo la respuesta MÁS RECIENTE
     puede pintar el panel; si una vieja llega tarde, se descarta. Sin esto, una
     respuesta rezagada sobreescribía el carrito y "desaparecía" lo recién agregado. */
  var cartSeq = 0;
  var pintarSiUltimo = function (mio) {
    return function (cart) { if (mio === cartSeq) pintarCarrito(cart); return cart; };
  };
  var refrescar = function () {
    var mio = ++cartSeq;
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(pintarSiUltimo(mio));
  };
  var cambiar = function (key, qty) {
    var mio = ++cartSeq;
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function (r) { return r.json(); }).then(pintarSiUltimo(mio));
  };
  var agregar = function (id) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, quantity: 1 }),
    }).then(function (r) {
      if (!r.ok) throw new Error("no se pudo agregar");
      return refrescar();
    });
  };

  function abrirDrawer() {
    var raiz = document.getElementById("carrito-drawer");
    if (!raiz) return;
    refrescar();
    raiz.hidden = false;
    requestAnimationFrame(function () { raiz.classList.add("abierto"); });
    bloquear(true);
    var cerrar = raiz.querySelector(".drawer-cerrar");
    if (cerrar) cerrar.focus();
  }
  function cerrarDrawer() {
    var raiz = document.getElementById("carrito-drawer");
    if (!raiz) return;
    raiz.classList.remove("abierto");
    bloquear(false);
    setTimeout(function () { raiz.hidden = true; }, 450);
  }

  /* ── Guía de tallas: modal ── */
  var tallasDisparador = null;
  var abrirTallas = function () {
    var modal = document.getElementById("modal-tallas");
    if (!modal) return;
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add("abierto"); });
    bloquear(true);
    var cerrarBtn = modal.querySelector(".modal-tallas-cerrar");
    if (cerrarBtn) cerrarBtn.focus();
  };
  var cerrarTallas = function () {
    var modal = document.getElementById("modal-tallas");
    if (!modal) return;
    modal.classList.remove("abierto");
    bloquear(false);
    setTimeout(function () { modal.hidden = true; }, 350);
    if (tallasDisparador) tallasDisparador.focus();
  };

  /* ── Buscador ── */
  var busqTimer = null;
  var abrirBusq = function () {
    var busq = document.getElementById("buscador");
    if (!busq) return;
    busq.hidden = false;
    requestAnimationFrame(function () { busq.classList.add("abierto"); });
    bloquear(true);
    var input = document.getElementById("buscador-input");
    if (input) input.focus();
  };
  var cerrarBusq = function () {
    var busq = document.getElementById("buscador");
    if (!busq) return;
    busq.classList.remove("abierto");
    bloquear(false);
    setTimeout(function () { busq.hidden = true; }, 300);
  };
  /* suggest.json entrega el precio en pesos (unidades), no en centavos como cart.js */
  var fmtSug = function (v) {
    return "$" + Math.round(parseFloat(v) || 0).toLocaleString("es-CO");
  };
  var fotoSug = function (p) {
    var u = p.featured_image && p.featured_image.url;
    if (!u) return "";
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=480";
  };
  var pintarResultados = function (productos, sugerencias, q) {
    var grid = document.getElementById("buscador-grid");
    var estado = document.getElementById("buscador-estado");
    var chips = document.getElementById("buscador-chips");
    var todos = document.getElementById("buscador-todos");
    if (!grid) return;
    if (todos) {
      todos.href = "/search?type=product" + (q ? "&q=" + encodeURIComponent(q) : "");
    }
    if (estado) {
      estado.textContent = q
        ? (productos.length >= 8
          ? "Primeros 8 resultados"
          : productos.length + (productos.length === 1 ? " resultado" : " resultados"))
        : "Escribe para buscar en la tienda";
    }
    if (chips) {
      var sug = (sugerencias || []).filter(function (s) {
        return s.text && s.text.toLowerCase() !== q.toLowerCase();
      }).slice(0, 6);
      chips.hidden = !q || sug.length === 0;
      chips.innerHTML = sug.map(function (s) {
        return '<button type="button" class="busq-chip etq" data-busq-chip="' +
          s.text.replace(/"/g, "&quot;") + '">' + (s.styled_text || s.text) + "</button>";
      }).join("");
    }
    if (q && productos.length === 0) {
      grid.innerHTML = '<p class="busq-nada t-sub">No encontramos eso, pero seguro hay algo que sí es lo tuyo.</p>';
      return;
    }
    grid.innerHTML = productos.map(function (p) {
      var img = fotoSug(p);
      var antes = parseFloat(p.compare_at_price_max) > parseFloat(p.price);
      return (
        '<a class="busq-item" href="' + p.url + '">' +
        '<span class="busq-foto">' + (img ? '<img src="' + img + '" alt="" loading="lazy" decoding="async">' : "") + "</span>" +
        "<p>" + p.title + "</p>" +
        '<span class="num">' + fmtSug(p.price) +
        (antes ? " <s>" + fmtSug(p.compare_at_price_max) + "</s>" : "") + "</span>" +
        "</a>"
      );
    }).join("");
  };

  /* ── Delegación global de clicks (aguanta re-renders del editor) ── */
  document.addEventListener("click", function (e) {
    var en = function (sel) { return e.target.closest(sel); };

    var quick = en("[data-quickadd]");
    if (quick) {
      e.preventDefault();
      var idQ = parseInt(quick.getAttribute("data-quickadd"), 10);
      if (!idQ) return;
      quick.disabled = true;
      agregar(idQ)
        .then(function () { avisar("Ya quedó en tu combo"); })
        .catch(function () { window.location.href = "/cart"; })
        .finally(function () { quick.disabled = false; });
      return;
    }

    if (en("#aviso-toast")) {
      var toast = document.getElementById("aviso-toast");
      toast.classList.remove("on");
      toast.hidden = true;
      abrirDrawer();
      return;
    }

    if (en("[data-abrir-carrito]")) { e.preventDefault(); abrirDrawer(); return; }
    if (en("[data-cerrar-carrito]")) { cerrarDrawer(); return; }
    if (en("[data-abrir-buscador]")) { abrirBusq(); return; }
    if (en("[data-cerrar-buscador]")) { cerrarBusq(); return; }
    var chip = en("[data-busq-chip]");
    if (chip) {
      var inpC = document.getElementById("buscador-input");
      if (inpC) {
        inpC.value = chip.getAttribute("data-busq-chip");
        inpC.dispatchEvent(new Event("input", { bubbles: true }));
        inpC.focus();
      }
      return;
    }
    if (en("[data-abrir-tallas]")) { tallasDisparador = en("[data-abrir-tallas]"); abrirTallas(); return; }
    if (en("[data-cerrar-tallas]")) { cerrarTallas(); return; }
    if (en("[data-abrir-look]")) { abrirLook(en("[data-abrir-look]").getAttribute("data-abrir-look")); return; }
    if (en("[data-cerrar-look]")) { cerrarLook(); return; }
    if (en("[data-look-scroll]")) {
      var lkBtn = en("[data-look-scroll]");
      var lkMarco = lkBtn.closest(".lookbook-marco");
      var lkFila = lkMarco ? lkMarco.querySelector(".lookbook-fila, .grid-productos.compacta") : null;
      if (lkFila) {
        /* Pasa la página completa: los siguientes 3 (o 4) de una. */
        lkFila.scrollBy({ left: lkFila.clientWidth * parseInt(lkBtn.getAttribute("data-look-scroll"), 10), behavior: "smooth" });
      }
      return;
    }
    if (en("[data-cerrar-popup]")) {
      var popC = document.getElementById("popup-entrada");
      if (popC) {
        popC.classList.remove("abierto");
        setTimeout(function () { popC.hidden = true; }, 260);
        try { sessionStorage.setItem("bhr-popup", "1"); } catch (err) { /* privado */ }
      }
      if (!en("a[data-cerrar-popup]")) return;
    }
    if (en("[data-volver]")) {
      var refVolver = document.referrer;
      if (window.history.length > 1 && refVolver && refVolver.indexOf(window.location.origin) === 0) {
        window.history.back();
      } else {
        window.location.href = "/";
      }
      return;
    }
    if (en("[data-abrir-menu]")) {
      var menuA = document.getElementById("menu-movil");
      if (menuA) { menuA.classList.add("abierto"); bloquear(true); }
      return;
    }
    if (en("[data-cerrar-menu]")) {
      var menuC = document.getElementById("menu-movil");
      if (menuC) { menuC.classList.remove("abierto"); bloquear(false); }
      return;
    }

    var fila = en(".item-carrito");
    if (fila) {
      var key = fila.getAttribute("data-key");
      var n = parseInt(fila.querySelector(".qty-n").textContent, 10) || 1;
      if (en("[data-quitar]")) cambiar(key, 0);
      else if (en("[data-qty]")) {
        var delta = parseInt(en("[data-qty]").getAttribute("data-qty"), 10);
        cambiar(key, Math.max(0, Math.min(9, n + delta)));
      }
      return;
    }

    var mini = en("[data-miniatura]");
    if (mini) {
      var principal = document.getElementById("pdp-foto-principal");
      if (!principal) return;
      principal.src = mini.getAttribute("data-src");
      principal.alt = mini.getAttribute("data-alt") || principal.alt;
      document.querySelectorAll("[data-miniatura]").forEach(function (x) { x.classList.remove("activa"); });
      mini.classList.add("activa");
    }
  });

  /* ── Lookbook: modal shop-the-look ── */
  var abrirLook = function (id) {
    var modal = document.getElementById("look-modal");
    var datos = document.querySelector('[data-look-json="' + id + '"]');
    if (!modal || !datos) return;
    var look;
    try { look = JSON.parse(datos.textContent); } catch (e) { return; }
    var img = document.getElementById("look-modal-img");
    var handle = document.getElementById("look-modal-handle");
    var prods = document.getElementById("look-modal-productos");
    if (img) { img.src = look.imagen || ""; img.alt = look.handle || "Look BOHOR"; }
    if (handle) {
      handle.textContent = look.handle || "";
      handle.hidden = !look.handle;
    }
    if (prods) {
      prods.innerHTML = (look.productos || []).map(function (p) {
        return (
          '<a class="look-prod" href="' + p.url + '">' +
          (p.foto ? '<img src="' + p.foto + '" alt="" loading="lazy">' : "") +
          '<span class="look-prod-info"><span class="look-prod-nombre">' + p.titulo + "</span>" +
          '<span class="look-prod-precio num">' + p.precio + "</span></span>" +
          '<span class="look-prod-flecha" aria-hidden="true">→</span></a>'
        );
      }).join("");
    }
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add("abierto"); });
    bloquear(true);
    var cerrar = modal.querySelector(".look-modal-cerrar");
    if (cerrar) cerrar.focus();
  };
  var cerrarLook = function () {
    var modal = document.getElementById("look-modal");
    if (!modal) return;
    modal.classList.remove("abierto");
    bloquear(false);
    setTimeout(function () { modal.hidden = true; }, 350);
  };

  /* ── Foto B de las tarjetas: se descarga solo al primer hover (desktop) ── */
  document.addEventListener("mouseover", function (e) {
    var tarjeta = e.target.closest(".tarjeta");
    if (!tarjeta) return;
    var b = tarjeta.querySelector("img.foto-b[data-src]");
    if (b) {
      b.src = b.getAttribute("data-src");
      b.removeAttribute("data-src");
    }
  }, { passive: true });

  /* ── Input del buscador (delegado) ── */
  document.addEventListener("input", function (e) {
    if (e.target.id !== "buscador-input") return;
    var q = e.target.value.trim();
    clearTimeout(busqTimer);
    if (!q) { pintarResultados([], [], ""); return; }
    busqTimer = setTimeout(function () {
      fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=hide")
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var res = (d.resources && d.resources.results) || {};
          pintarResultados(res.products || [], res.queries || [], q);
        })
        .catch(function () { /* el enlace a /search sigue disponible */ });
    }, 220);
  });

  /* ── Escape global ── */
  window.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var raiz = document.getElementById("carrito-drawer");
    var modal = document.getElementById("modal-tallas");
    var busq = document.getElementById("buscador");
    var menu = document.getElementById("menu-movil");
    var look = document.getElementById("look-modal");
    var popEsc = document.getElementById("popup-entrada");
    if (raiz && !raiz.hidden) cerrarDrawer();
    if (modal && !modal.hidden) cerrarTallas();
    if (busq && !busq.hidden) cerrarBusq();
    if (look && !look.hidden) cerrarLook();
    if (popEsc && !popEsc.hidden) {
      popEsc.classList.remove("abierto");
      setTimeout(function () { popEsc.hidden = true; }, 260);
      try { sessionStorage.setItem("bhr-popup", "1"); } catch (err) { /* privado */ }
    }
    if (menu && menu.classList.contains("abierto")) { menu.classList.remove("abierto"); bloquear(false); }
  });

  /* ── Producto: talla obligatoria + agregar + barra móvil ── */
  var initProducto = function () {
    var formulario = document.getElementById("form-producto");
    if (!formulario || formulario.getAttribute("data-init") === "1") return;
    formulario.setAttribute("data-init", "1");

    var aviso = document.getElementById("talla-aviso");
    var estadoTalla = document.getElementById("talla-estado");
    var multiTalla = formulario.getAttribute("data-multi") === "1";

    formulario.querySelectorAll('input[name="id"]').forEach(function (r) {
      r.addEventListener("change", function () {
        if (aviso) aviso.hidden = true;
        if (estadoTalla) estadoTalla.textContent = "Talla " + r.getAttribute("data-talla");
      });
    });

    var enviarAgregar = function () {
      var elegido = formulario.querySelector('input[name="id"]:checked');
      if (multiTalla && !elegido) {
        if (aviso) aviso.hidden = false;
        var caja = formulario.querySelector(".pdp-tallas");
        if (caja) {
          caja.classList.remove("sacude");
          void caja.offsetWidth;
          caja.classList.add("sacude");
        }
        return;
      }
      var id = elegido ? parseInt(elegido.value, 10) : parseInt(formulario.getAttribute("data-variante-unica"), 10);
      if (!id) return;
      var botones = document.querySelectorAll("[data-agregar-producto]");
      botones.forEach(function (b) { b.disabled = true; });
      agregar(id)
        .then(abrirDrawer)
        .catch(function () { window.location.href = "/cart"; })
        .finally(function () { botones.forEach(function (b) { b.disabled = false; }); });
    };

    formulario.addEventListener("submit", function (e) { e.preventDefault(); enviarAgregar(); });
    document.querySelectorAll("[data-agregar-producto]").forEach(function (b) {
      if (!formulario.contains(b)) b.addEventListener("click", enviarAgregar);
    });

    var barra = document.querySelector(".pdp-barra");
    if (barra) {
      var alScrollBarra = function () {
        barra.classList.toggle(
          "oculta",
          window.innerHeight + window.scrollY > document.body.scrollHeight - 220
        );
      };
      alScrollBarra();
      window.addEventListener("scroll", alScrollBarra, { passive: true });
    }

    /* Completa el look: baraja las candidatas en cada carga (rotan siempre) */
    var gridLooks = document.querySelector("[data-rotar-looks]");
    if (gridLooks && gridLooks.getAttribute("data-init") !== "1") {
      gridLooks.setAttribute("data-init", "1");
      var candidatas = [].slice.call(gridLooks.children);
      if (candidatas.length > 4) {
        candidatas.sort(function () { return Math.random() - 0.5; });
        candidatas.forEach(function (el) { el.hidden = true; });
        candidatas.slice(0, 4).forEach(function (el) {
          el.querySelectorAll("img.foto-a[data-src]").forEach(function (img) {
            img.src = img.getAttribute("data-src");
            var ss = img.getAttribute("data-srcset");
            if (ss) img.setAttribute("srcset", ss);
            img.removeAttribute("data-src");
            img.removeAttribute("data-srcset");
          });
          el.classList.remove("look-extra");
          el.classList.add("rv", "in");
          el.hidden = false;
          gridLooks.appendChild(el);
        });
      }
    }
  };

  /* ── PLP: orden por URL ── */
  var initPlp = function () {
    var orden = document.getElementById("plp-orden-select");
    if (!orden || orden.getAttribute("data-init") === "1") return;
    orden.setAttribute("data-init", "1");
    orden.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", orden.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  };

  /* ── Popup de entrada: una vez por sesión, con retraso (todas las páginas) ── */
  var initPopup = function () {
    var popE = document.getElementById("popup-entrada");
    if (!popE || popE.getAttribute("data-init") === "1") return;
    popE.setAttribute("data-init", "1");
    var abrirPop = function () {
      popE.hidden = false;
      requestAnimationFrame(function () { popE.classList.add("abierto"); });
    };
    var enEditor = window.Shopify && window.Shopify.designMode;
    var popVisto = false;
    try { popVisto = !!sessionStorage.getItem("bhr-popup"); } catch (err) { /* privado */ }
    if (!enEditor && !popVisto) {
      setTimeout(abrirPop, (parseInt(popE.getAttribute("data-retraso"), 10) || 2) * 1000);
    }
    if (enEditor) {
      document.addEventListener("shopify:section:select", function (e) { if (e.target && e.target.contains(popE)) abrirPop(); });
      document.addEventListener("shopify:section:deselect", function (e) {
        if (e.target && e.target.contains(popE)) { popE.classList.remove("abierto"); setTimeout(function () { popE.hidden = true; }, 260); }
      });
    }
  };

  /* ── Filas que rotan: barajar el orden en cada carga (home y donde estén) ── */
  var initRotarFilas = function () {
    document.querySelectorAll("[data-rotar-fila]").forEach(function (filaR) {
      if (filaR.getAttribute("data-rotada") === "1") return;
      filaR.setAttribute("data-rotada", "1");
      if (window.Shopify && window.Shopify.designMode) return;
      var hijosR = [].slice.call(filaR.children);
      hijosR.sort(function () { return Math.random() - 0.5; });
      hijosR.forEach(function (h) { filaR.appendChild(h); });
    });
  };

  initProducto();
  initPlp();
  initPopup();
  initRotarFilas();

  /* ── Re-init cuando el editor de temas re-renderiza secciones ── */
  document.addEventListener("shopify:section:load", function (e) {
    observarReveals(e.target);
    alScroll();
    initProducto();
    initPlp();
    initPopup();
    initRotarFilas();
  });

  /* ── Intro (1 vez por sesión) ── */
  var intro = document.getElementById("intro");
  if (intro) {
    var vista = false;
    try { vista = sessionStorage.getItem("bohor-intro") === "1"; } catch (e) { vista = true; }
    if (vista || reducido || window.Shopify && window.Shopify.designMode) {
      intro.hidden = true;
    } else {
      bloquear(true);
      var salir = function () {
        try { sessionStorage.setItem("bohor-intro", "1"); } catch (e) { /* sin storage */ }
        intro.classList.add("saliendo");
        bloquear(false);
        setTimeout(function () { intro.hidden = true; }, 750);
      };
      intro.addEventListener("click", salir);
      setTimeout(salir, 2150);
    }
  }

  /* ── Cursor estrella-brújula (puntero fino) ── */
  var cursorActivo = document.body.getAttribute("data-cursor") === "1";
  if (cursorActivo && window.matchMedia("(pointer: fine)").matches && !reducido) {
    document.body.classList.add("con-cursor");
    var marca = document.createElement("div");
    marca.className = "cursor-marca";
    marca.innerHTML = '<svg viewBox="0 0 100 100" fill="currentColor" aria-hidden="true"><polygon points="50,1 58,42 99,50 58,58 50,99 42,58 1,50 42,42"/><polygon points="50,1 58,42 99,50 58,58 50,99 42,58 1,50 42,42" transform="translate(50 50) scale(0.6) rotate(45) translate(-50 -50)" opacity="0.92"/></svg>';
    var anillo = document.createElement("div");
    anillo.className = "cursor-anillo";
    document.body.append(marca, anillo);
    var rx = -100, ry = -100, px = -100, py = -100;
    window.addEventListener("pointermove", function (e) {
      px = e.clientX; py = e.clientY;
      marca.style.transform = "translate(" + (px - 6.5) + "px," + (py - 6.5) + "px)";
      var sobre = e.target.closest("a, button, [role=button], input, select, label, summary");
      anillo.classList.toggle("on", !!sobre);
      marca.classList.toggle("on", !!sobre);
    }, { passive: true });
    var animar = function () {
      rx += (px - rx) * 0.18; ry += (py - ry) * 0.18;
      var mitad = anillo.classList.contains("on") ? 23 : 17;
      anillo.style.transform = "translate(" + (rx - mitad) + "px," + (ry - mitad) + "px)";
      requestAnimationFrame(animar);
    };
    animar();
  }

  /* estado inicial del carrito */
  refrescar();
})();
